exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-container-graphs{display:grid;column-gap:10px;grid-template-columns:11rem auto}@media (max-width:769px){.grid-container-graphs{grid-template-columns:auto}}.zoomed{animation:zoomAnimation .5s both}@keyframes zoomAnimation{0%{transform:scale(1)}50%{transform:scale(1.05)}to{transform:scale(1)}}.slide-enter{transform:translateX(30vw)}.slide-enter-active,.slide-leave-active{transition:all .3s ease-in}.slide-leave-to,.slide-two-enter{transform:translateX(30vw)}.slide-two-enter-active,.slide-two-leave-active{transition:all .3s ease-in}.slide-two-leave-to{transform:translateX(30vw)}.button-menu{position:fixed;top:0;padding:15px;right:0;transition:all .3s ease 0s;z-index:61}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3384d0f2","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/frpm/Demographic.vue
// module id = 1185
// module chunks = 2